// extracted by mini-css-extract-plugin
module.exports = {"career-guides":"career-guides_career-guides__tcEch","list":"career-guides_list__qFFE6","more":"career-guides_more__l_Gbg"};